import { Route, Routes } from "react-router-dom";
import { memo } from "react";
import SelectProductDashboard from "../screens/Products/SelectProductDashboard";
import CreatePost from "../screens/Products/Create/CreatePost";
import { CreateEvent } from "../screens/CreateEvent/CreateEvent";
import CreateExternalLink from "../screens/CreateEvent/CreateExternalLink";
import CreateProduct from "../screens/Products/Create/CreateProduct";

const NewProductRoute = memo(function NewProductRouteFn() {
  return (
    <Routes>
      <Route path="/">
        <Route index element={<SelectProductDashboard />} />
        <Route path="post" element={<CreatePost />} />
        {["video", "audio", "pdf", "custom-product"].map((path) => (
          <Route key={path} path={path} element={<CreateProduct />} />
        ))}
        <Route path="event" element={<CreateEvent />} />
        <Route path="webinar" element={<CreateEvent />} />
        <Route path="link-event" element={<CreateExternalLink />} />
      </Route>
    </Routes>
  );
});

export default NewProductRoute;
